export default {
    user: { loading: true },
    documentData: {
        documents: [],
        // pending states:
        isUploading: false, // upload to blob storage
        isFetching: false, // get from db
    },
    sharings: {
        sharings: [],
    },
    scrapeData: {
        isScraping: false,
        scrapes: [],
    },
    calculations: { isCalculating: false, pensionAnalysis: {} },
    penlyplay: null,
    affiliates: {},
    pensiongoals: {
        saved:false,
        error: undefined,
        pension: {},
        basic: {},
    },
};
